// extracted by mini-css-extract-plugin
module.exports = {"container":"Home_title_container__1Wu87","title":"Home_title_title__2UO3F","subTitle":"Home_title_subTitle__OrQcW","logo":"Home_title_logo__26SgS"};